// extracted by mini-css-extract-plugin
module.exports = {"block":"balanceLink_block__2uE69","topUp":"balanceLink_topUp__qG5UF"};